<div class="list-item">
  <app-photo size="m" [rounded]="true" [type]="'photo'" [id]="data?.photoId" [text]="data?.name"></app-photo>

  <div class="list-item__info">
    <div class="list-item__title">
      <app-icon
        [src]="data && data.chatTypeId === 2 ? 'megaphone' : 'users'"
        [size]="'20px'"
        [tuiHint]="
          data && data.chatTypeId === 2 ? ('common.labels.channel' | translate) : ('common.labels.group' | translate)
        "
      ></app-icon>

      <span class="list-item__text text_size-m text_color-01 text_truncate">
        {{ data?.name }}
      </span>
    </div>

    <span *ngIf="data?.description" class="list-item__text text_size-xs text_color-03 text_truncate">
      {{ data?.description }}
    </span>
  </div>
</div>
